import { render, staticRenderFns } from "./mailMessage.vue?vue&type=template&id=955e3986&scoped=true&"
import script from "./mailMessage.vue?vue&type=script&lang=js&"
export * from "./mailMessage.vue?vue&type=script&lang=js&"
import style0 from "./mailMessage.vue?vue&type=style&index=0&id=955e3986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955e3986",
  null
  
)

export default component.exports